<template>
  <v-card color="#F5F5F5" class="back pa-2 mt-0 report-card">
    <v-card-title class="d-flex justify-space-between"
      ><span>
        1.4 - {{ $t('Equipamentos Parados x Tipo de Pendencia') }}
        <v-tooltip color="white" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="black" dark v-bind="attrs" v-on="on">
              mdi-information-outline
            </v-icon>
          </template>
          <span class="black--text">{{
            $t(
              "Apresenta a lista dos equipamentos com O.S. em aberto, nos quais o campo 'Máquina Parada' está preenchido sem data de retorno."
            )
          }}</span>
        </v-tooltip></span
      >
      <v-btn
        @click="requestExcel"
        depressed
        small
        class="secondary-button mr-1"
      >
        <v-icon>mdi-microsoft-excel</v-icon>
      </v-btn></v-card-title
    >

    <v-divider></v-divider>

    <v-card-text>
      <strong
        >Qtd. {{ $t('Equipamentos Parados') }}: {{ pager.totalItems }}</strong
      >

      <v-alert type="error" class="mt-3 pa-0" v-if="data.length == 0">
        {{ $t('Nenhuma registro encontrado') }}
      </v-alert>
      <v-data-table
        v-else
        :loading="loading"
        :loading-text="$t('Carregando...')"
        :no-data-text="$t('Nenhum registro encontrado')"
        :headers="header"
        dense
        item-key="osNumber"
        :items="data"
        class="main-table"
        hide-default-footer
        hide-default-header
        :header-props="headerProps"
        :items-per-page="data.length"
      >
        <template #header="{ props, on }">
          <thead>
            <tr>
              <th
                class="text-center"
                v-for="header in props.headers"
                :key="header.value"
              >
                <v-simple-checkbox
                  v-if="header.value === 'data-table-select'"
                  v-model="props.everyItem"
                  :indeterminate="props.someItems && !props.everyItem"
                  color="purple"
                  @input="on['toggle-select-all']"
                ></v-simple-checkbox>

                <div>
                  <v-hover v-slot="{ hover }">
                    <div>
                      <span>{{ $t(header.text) }}</span>
                      <v-icon
                        v-if="
                          hover &&
                          header.value != 'data-table-select' &&
                          header.value != 'actions'
                        "
                        color="white"
                        class="mx-2"
                        @click="on.sort(header.value)"
                      >
                        {{
                          props.options.sortBy.includes(header.value)
                            ? `mdi-chevron-down`
                            : `mdi-chevron-up`
                        }}
                      </v-icon>
                    </div>
                  </v-hover>
                </div>
              </th>
            </tr>
          </thead>
        </template>

        <template #[`item.solicitation`]="{ item }">
          {{ formatDate(item.solicitation) }}
        </template>
      </v-data-table>

      <div class="pagination">
        <div class="item-pagination block-two">
          <v-pagination
            class="pagination-item"
            v-model="page"
            :length="pager.totalPages"
            :total-visible="3"
          ></v-pagination>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'

export default {
  name: 'stoppedEquipPendingType',

  created() {
    this.list()
  },

  props: {
    filterProp: Object,
  },

  data() {
    return {
      page: 1,
      apiService: new ApiService(),
      data: [],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      header: [
        {
          text: '',
          align: 'left',
          value: '',
          sortable: false,
        },
        {
          text: 'Número O.S.',
          align: 'center',
          value: 'osNumber',
          sortable: false,
        },
        {
          text: 'Equipamento',
          align: 'center',
          value: 'name',
          sortable: false,
        },
        {
          text: 'Identificação',
          align: 'center',
          value: 'identification',
          sortable: false,
        },
        {
          text: 'Setor',
          align: 'center',
          value: 'sector',
          sortable: false,
        },
        {
          text: 'Data solicitação',
          align: 'center',
          value: 'solicitation',
          sortable: false,
        },
        {
          text: 'Tipo pendência',
          align: 'center',
          value: 'service',
          sortable: false,
        },
      ],
      loading: false,
      pager: {},
    }
  },

  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `Stopped_Equipment_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/stoppedEquipmentPendingType', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    formatDate(date) {
      return Utils.moment(date)
    },

    list() {
      this.loading = true

      this.apiService
        .post('reports/stoppedEquipmentPendingType', this.filterProp)
        .then((response) => {
          this.data = response.content.objects
          this.pager = response.content.pager
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
  watch: {
    filterProp() {
      this.list()
    },

    page() {
      this.filterProp.page = this.page
      this.list()
    },
  },
}
</script>

<style></style>
